import React from 'react';
import { useTheme } from 'styled-components';

// Definindo o tipo da prop
interface CustomSpanProps {
  texto: 'Sim' | 'Não' | 'Ativo' | 'Inativo';
  'data-testid'?: boolean | string;
  name?: string;
}

const CustomSpan: React.FC<CustomSpanProps> = ({
  texto,
  name,
  'data-testid': dataTestId,
}) => {
  // Definindo as cores com base no valor do texto
  const theme = useTheme();
  const background =
    texto === 'Sim' || texto === 'Ativo'
      ? theme.colors.verde
      : theme.colors.vermelho;
  const color = texto === 'Sim' || texto === 'Ativo' ? 'white' : 'white';

  const testId = React.useMemo(() => {
    if (typeof dataTestId === 'string') return dataTestId;
    if (dataTestId === false) return undefined;
    return `span-${name || texto.toLowerCase()}`;
  }, [dataTestId, name, texto]);

  return (
    <span
      style={{
        backgroundColor: background,
        padding: '3px 10px',
        borderRadius: '5px',
        color: color,
      }}
      data-testid={testId}
    >
      {texto}
    </span>
  );
};

export default CustomSpan;
